<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('message.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/UserList' }">{{$t('message.vueUser.crumbUserManager')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <el-form ref="userForm" :model="userForm" :inline="true" class="demo-form-inline" size="mini" label-width="120px">
        <el-form-item :label="$t('message.vueUser.labIsDisabled')+' :'">
            <el-select v-model="userForm.isDisabled" :placeholder="$t('message.pleaseSelect')" style="width:120px" size="mini">
                <el-option :label="$t('message.vueUser.selIsDisabledYes')" value="true"></el-option>
                <el-option :label="$t('message.vueUser.selIsDisabledNo')" value="false"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.vueUser.labCompanyName')+' :'" prop="company">
            <el-select v-model="userForm.company" value-key="id" :placeholder="$t('message.pleaseSelect')" style="width:120px" @change="getDepartment($event)" filterable size="mini">
                <el-option :label="this.$t('message.all')" value=""></el-option>
                <el-option v-for="item in companylist"
                           :key="item.id"
                           :label="item.companyName"
                           :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.vueUser.labDepartmentName')+' :'" prop="department">
            <el-select v-model="userForm.department" value-key="id" :placeholder="$t('message.pleaseSelect')" style="width:120px" filterable size="mini">
                <el-option :label="this.$t('message.all')" value=""></el-option>
                <el-option v-for="item in departmentlist"
                           :key="item.id"
                           :label="item.departmentName"
                           :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.vueUser.labKeyword')+' :'">
            <el-input v-model="userForm.keyword" :placeholder="$t('message.vueUser.plaSearch')" size="mini" style="width:120px"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button class="btn_search" id="btn_search" @click="submitSearch"
                       icon="el-icon-search" size="mini">{{$t('message.search')}}</el-button>
        </el-form-item>
        <el-row>
            <el-form-item>
                <el-button type="primary" id="btn_add" @click="add"
                           icon="el-icon-circle-plus-outline" size="mini" class="btn_add">{{$t('message.vueProduct.button_add')}}</el-button>
            </el-form-item>
        </el-row>
    </el-form>
    <el-table :data="tableData" style="width: 100%" border size="mini"
              highlight-current-row
              :stripe="true"
              :header-cell-style="{'background':'#81761852','color':'#2F4F4F','font-size': '12px','text-align':'center'}">
        <el-table-column prop="Company" :label="$t('message.vueUser.labCompanyName')"
                         width="130">
            <template #default="scope">
                <span>{{scope.row.companyName}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="Department" :label="$t('message.vueUser.labDepartmentName')"
                         width="120">
            <template #default="scope">
                <span>{{scope.row.departmentName}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="Account" :label="$t('message.vueUser.labAccount')"
                         width="140">
            <template #default="scope">
                <span>{{scope.row.account}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="Number" :label="$t('message.vueUser.labNumber')"
                         width="110">
            <template #default="scope">
                <span>{{scope.row.number}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="Email" :label="$t('message.vueUser.labEmail')"
                         width="280">
            <template #default="scope">
                <span>{{scope.row.email}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="isDisabled"
                         :label="$t('message.vueUser.labDisabled')"
                         width="100">
            <template #default="scope">
                <el-tooltip :content="$t('message.vueUser.labIsDisabled')" placement="top" style="margin-right:10px">
                    <el-switch v-model="scope.row.isDisabled" active-color="#ff4949" inactive-color="#13ce66" :loading="scope.row.isLoading" :before-change="()=>changeIsDisabled(scope.row)"></el-switch>
                </el-tooltip>
                <span v-if="scope.row.isDisabled===true">
                    {{$t('message.vueUser.selIsDisabledYes')}}
                </span>
                <span v-else>
                    {{$t('message.vueUser.selIsDisabledNo')}}
                </span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('message.operate')"
                         min-width="300">
            <template #default="scope">
                <el-button size="mini"
                           icon="el-icon-tickets"
                           class="button_detail"
                           @click="query(scope.row)">{{$t('message.details')}}</el-button>
                <el-button size="mini"
                           icon="el-icon-edit"
                           class="button_edit"
                           v-if="!(scope.row.isDisabled)"
                           @click="edit(scope.row)">{{$t('message.edit')}}</el-button>
                <el-button size="mini"
                           icon="el-icon-edit"
                           type="warning"
                           class="btn_delete2"
                           v-if="!(scope.row.isDisabled)"
                           @click="examineBtn(scope.row)">{{$t('message.vueUser.editPassword')}}</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="block">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageIndex"
                       :page-sizes="[10, 25, 50, 75, 100]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="count">
        </el-pagination>
    </div>
    <userEditPassword ref="msgBtn" :formType="userForm.rowId"></userEditPassword>
</template>
<style>
    .el-table .success-row {
        background: #DFEAF5;
    }
    .btn_search {
        color: #fff;
        background-color: green;
        font-weight: bolder;
    }
    .btn_add {
        font-weight: bolder;
    }
    .btn_delete2 {
        font-weight: bolder;
    }
    .button_detail {
        font-weight: bolder;
    }
    .button_edit {
        color: #fff;
        background-color: orange;
        font-weight: bolder;
    }
</style>
<script>
    import AppStorage from '@/common/storage/app-storage'
    import userEditPassword from '@/components/User/UserEditPassword'
    export default {
        name: 'User',
        components: {
            //挂载组件
            userEditPassword, //自定义的标签
        },
        data() {
            return {
                tableData: null,
                language: AppStorage.getLanguage(),
                companylist: [],
                departmentlist: [],
                userForm: {
                    company: {},
                    department: {},
                    keyword:'',
                    isDisabled: "false",
                    rowId:0,
                },
                pageIndex: 1,
                pageSize: 50,
                count: 0,
            }
        },
        methods: {
            getCompany() {
                this.axios
                    .get('/api/company/getcompanylist', {
                        params: {
                            isFactory: 2,
                            userNumber: AppStorage.getNumber(),
                            isAll: false,
                        }
                    }).then(response => {
                        if (response.data.code == 1) {
                            var infos = response.data.data;
                            this.companylist = infos;
                        }
                    })
            },
            getDepartment(opt) {
                this.departmentlist = [];
                this.userForm.departmentId = "";
                if (opt.id != "") {
                    this.axios
                        .get('/api/department/getdepartmentlist', {
                            params: {
                                companyNumber: opt.companyNumber,
                                userNumber: AppStorage.getNumber(),
                                isAll: false,
                            }
                        }).then(response => {
                            if (response.data.code == 1) {
                                var infos = response.data.data;
                                this.departmentlist = infos;
                            }
                        })
                }
            },
            loadPage() {
                this.axios
                    .get('/api/user/getuserpage', {
                        params: {
                            isDisabled: this.userForm.isDisabled,
                            companyNumber: this.userForm.company.companyNumber,
                            departmentNumber: this.userForm.department.departmentNumber,
                            keyword: this.userForm.keyword,
                            userNumber: AppStorage.getNumber(),
                            pageIndex: this.pageIndex,
                            pageSize: this.pageSize
                        }
                    }) .then(response => {
                        if (response.data.code == 1) {
                            var infos = response.data.data;
                            this.tableData = infos.items;
                            this.count = infos.count;
                        }
                    })
            },
            submitSearch() {
                this.pageIndex = 1;
                this.loadPage();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.loadPage();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.loadPage();
            },
            add() {
                this.$router.push({
                    path: "/UserAdd",
                    query: { id: 0 }
                });
            },
            edit(row) {
                this.$router.push({
                    path: "/UserEdit",
                    query: { id: row.id }
                });
            },
            examineBtn(row) {
                this.$refs.msgBtn.init(row.id);
            },
            query(row) {
                this.$router.push({
                    path: "/UserDetails",
                    query: { id: row.id }
                });
            },
            changeIsDisabled(row) {
                var isDisabled = false;
                if (row.isDisabled == false) {
                    isDisabled = true;
                }
                row.isLoading = true;
                return new Promise(resolve => {
                    this.axios
                        .post('/api/user/disableduser', {
                            Id: row.id,
                            IsDisabled: isDisabled,
                            UserNumber: AppStorage.getNumber(),
                        })
                        .then(response => {
                            row.isLoading = false;
                            if (response.data.code != 1) {
                                this.$message.error(this.$t('message.error'));
                                return resolve(false)
                            } else {
                                this.$message.success(this.$t('message.success'));
                                return resolve(true);
                            }
                        }).catch(error => {
                            console.log(error);
                            row.isLoading = false;
                            this.$message.error(this.$t('message.messageBox.connecterror'));
                            return resolve(false);
                        });
                })
            },
        },
        mounted() {
            this.submitSearch();
            this.getCompany();
        },
        watch: {
            $route() {
                //响应路由参数的变化
                this.submitSearch();
            }
        }

    };
</script>